/** hook root session reducer
 * Gestisco lo stato complesso
 */

import { widgetsConstants } from "../actions/main/widgets";

export const initialState = {
  accountantIdSelected: "",
  accountantUuidSelected: "",
  accountantSelected: "",
  clientIdSelected: "",
  companySelected: "",
  companyUuidSelected: "",
  companiesRequestSize: 40,
  companiesRequestPage: 0,
  companiesRequestText: "",
  myType: null,
  menuToggle: localStorage.getItem("menuToggle") || "unfold",
  isIntegrated: false,
  /* mi serve per discriminare lista scadenze da home commercialista o da scheda cliente
                  per attivare voci di menu se sono su dettaglio scadenza prevPath è giusto che valga "/" */
  prevPath: "/",
  prevPathname: "",
  /* mi serve per avere il link del torna indietro corretto.
              Se sono su dettaglio scadenze e provengo dalla lista devo andare su /scadenze se provengo da home su / */
  realPrevPath: "/",
  stepsViewed: true, // Per il tour. La inizializzo a true perchè così faccio in modo che ci siano i permessi altrimenti avrei errore mancando i permessi a t0
  widgets: {
    fullscreenOverlay: {
      visible: false,
      params: {}
    }
  }
};

function mainStatus(state, action) {
  let defaultState = typeof state === "undefined" ? initialState : state;
  switch (action.type) {
  case "setIntegrated":
    return {
      ...defaultState,
      isIntegrated: true
    };
  case "removeIntegrated":
    return {
      ...defaultState,
      isIntegrated: false
    };
  case "changeAccountant":
    return {
      ...defaultState,
      accountantUuidSelected: action.accountantUuidSelected,
      accountantIdSelected: action.accountantIdSelected,
      accountantSelected: action.accountantSelected,
      myType: action.myType ? action.myType : defaultState.myType
    };
  case "changeCompany": {
    return {
      ...defaultState,
      companiesRequestPage: action.companiesRequestPage ? action.companiesRequestPage : defaultState.companiesRequestPage,
      companiesRequestText:
          action.companiesRequestText || action.companiesRequestText === "" ? action.companiesRequestText : defaultState.companiesRequestText,
      accountantUuidSelected: action.accountantUuidSelected ? action.accountantUuidSelected : defaultState.accountantUuidSelected,
      accountantIdSelected: action.accountantIdSelected ? action.accountantIdSelected : defaultState.accountantIdSelected,
      accountantSelected: action.accountantSelected ? action.accountantSelected : defaultState.accountantSelected,
      companyUuidSelected: action.companyUuidSelected,
      clientIdSelected: action.clientIdSelected,
      companySelected: action.companySelected,
      myType: action.myType ? action.myType : defaultState.myType
    };
  }
  case "setNewPage": {
    return {
      ...defaultState,
      companiesRequestPage: action.page
    };
  }
  case "setFullTextSearch": {
    return {
      ...defaultState,
      companiesRequestText: action.searchTerm
      /* companiesRequestPage:
            state.companiesRequestPage > 0
              ? -1
              : 0 /** risolve un problema di ricerca e paginazione ulteriore */
    };
  }
  case "setUserType":
    return {
      ...defaultState,
      myType: action.userType
    };
  case "setPaths":
    return {
      ...defaultState,
      prevPathname: action.prevPathname,
      /** se sono in dettaglio scadenza non voglio mantenere questa info */
      prevPath: action.prevPath,
      realPrevPath: action.realPrevPath
    };
  case widgetsConstants.SHOW_FULLSCREEN_OVERLAY:
    return {
      ...defaultState,
      widgets: {
        ...defaultState.widgets,
        fullscreenOverlay: {
          visible: true,
          params: action || {}
        }
      }
    };
  case widgetsConstants.HIDE_FULLSCREEN_OVERLAY:
    return {
      ...defaultState,
      widgets: {
        ...defaultState.widgets,
        fullscreenOverlay: {
          visible: false,
          params: {}
        }
      }
    };
  case "UPDATE_LOGIN_DATA_MAIN":
    return { ...defaultState, ...action.payload };
  case "SET_MENU_TOGGLE":
    return { ...defaultState, menuToggle: action.payload };
  default:
    return defaultState;
  }
}

export default mainStatus;
